export const ORGANIZATION_CATEGORIES = {
  FIRST: 'firstCategory',
  FORTH: 'forthCategory',
  SECOND: 'secondCategory',
  THIRD: 'thirdCategory',
  WITHOUT_CATEGORY: 'withoutCategory',
};
